/* istanbul ignore file */
import React from 'react';
import { TextField, LinkField, DateField, EnumField } from 'framework/ui/field';
import RequiredResourcesListField from 'domain/sales/opportunity/presale/output/shared/field/RequiredResourcesListField';
import { OPPORTUNITY_PROJECT_TYPE } from 'domain/shared/presale';

const PresaleOutputFields = () => {
  return (
    <>
      <TextField source="descriptionText" label="Description" />
      <LinkField source="sharepointLink" label="Sharepoint Link" />
      <EnumField source="projectType" options={OPPORTUNITY_PROJECT_TYPE} />
      <DateField source="expectedProjectStart" label="Expected Project Start" />
      <RequiredResourcesListField source="requiredResources" label="Team structure" />
    </>
  );
};

export default PresaleOutputFields;
